// extracted by mini-css-extract-plugin
export default {"Locations":"Locations_Locations__bcpYi","Locations__new":"Locations_Locations__new__cDsJn","Locations__table":"Locations_Locations__table__wO2N6"};